import { create } from 'zustand';

import {
	isDashboardBannerDismissed,
	setDashboardBannerDismissed
} from 'src/common/services/api/LocalStorageApi';

interface BannerStore {
	visible: boolean;

	setVisible: (visible: boolean) => void;
	hidePermanently: () => void;
}

export const useBannerStore = create<BannerStore>((set) => ({
	visible: !isDashboardBannerDismissed(),

	setVisible: (visible) => set({ visible }),
	hidePermanently: () => {
		set({ visible: false });
		setDashboardBannerDismissed(true);
	}
}));
